import Http from '@/plugins/http.js';

export default {
    // 获取字段操作符
    getOperatorOptions() {
        return Http.GET(`api/list/GetOperatorOptions`);
    },

    /**
     * 获取数据源
     * @param formCode
     * @param isFilterDelFields 是否过滤已被删除的数据源字段 boolean
     */
    getFormDataSource(formCode, isFilterDelFields) {
        return Http.GET(
            `api/DataSource/GetDataSourceNew/${formCode}/${
                isFilterDelFields ? isFilterDelFields : ''
            }`
        );
    },

    /**
     * 获取列表设置
     * @param {string} formCode
     */
    getListSetting(formCode) {
        return Http.GET(`api/list/GetListSetting/` + formCode);
    },

    /**
     * 保存组件配置信息
     * @param {*} appItemCode
     * @param {*} component
     */
    saveAppComponentSetting(appItemCode, component) {
        return Http.POST(`api/App/SaveAppComponentSetting/${appItemCode}`, component);
    },
    /**
     * 获取组件配置信息
     * @param {*} componentId
     */
    getAppComponentSetting(componentId) {
        return Http.GET(`api/App/GetAppComponentSetting/${componentId}`);
    },

    /**
     * 获取应用菜单模型
     * @param {*} appItemCode
     */
    getAppItemView(appItemCode) {
        return Http.GET(`api/App/GetAppItemView/${appItemCode}`);
    },

    /**
     * 获取列表基础设置
     * @param {string} formCode appItemCode
     */
    getListBasicSetting(formCode) {
        return Http.GET(`api/list/GetListBasicSetting/` + formCode);
    },

    /**
     * 获取列表高级设置
     * @param {string} formCode appItemCode
     */
    getListAdvancedSetting(formCode) {
        return Http.GET(`api/list/GetListAdvancedSetting/` + formCode);
    },

    /**
     * 保存列表高级设置
     * @param settingModel  高级设置实体
     */
    saveListAdvancedSetting(settingModel) {
        return Http.POST(`api/list/SaveListAdvancedSetting/`, settingModel);
    },
    /**保存列表基础设置 */
    saveListBasicSetting(listSetting) {
        return Http.POST(`api/list/SaveListBasicSetting`, listSetting);
    },

    /**保存列表行颜色设置 */
    saveListRowColor(itemCode, rowColorSetting) {
        return Http.POST(`api/list/SaveListRowColor/${itemCode}`, rowColorSetting);
    },

    /**
     * 保存应用功能设置
     * @param {*} appItemCode
     * @param {*} container
     */
    saveAppItemSetting(appItemCode, container) {
        return Http.POST(`api/App/SaveAppItemSetting/${appItemCode}`, container);
    },
    /**
     * 同步数据源与列表字段
     * @param {Number} type      必填
     * @param {String} itemCode  必填
     * @param {*} field          {"Title": "string","Code": "string"}
     * @param {String} subCode
     */
    updateListSettingByField(type, itemCode, field, subCode = '') {
        let api = `/api/List/UpdateListSettingByField/${type}/${itemCode}`;
        if (subCode && subCode.length > 0) {
            api += `/${subCode}`;
        }
        return Http.POST(api, field);
    },
    /**
     * 数据范围表达式验证
     * @param {*} componentKey
     * @param {*} formulaText
     */
    checkListScopeConditionFormula(componentKey, formulaText) {
        const param = {
            ComponentKey: componentKey,
            FormulaText: formulaText,
        };
        return Http.POST(`api/list/CheckListScopeConditionFormula`, param);
    },

    saveListSetting(param) {
        return Http.POST(`api/list/SaveListSetting`, param);
    },
    publishAppMenu(appitemcode, status) {
        return Http.GET(`api/APP/PublishAppMenu/${appitemcode}/${status}`);
    },
    getUserPermitionData(ObjectID) {
        return Http.GET(`api/APP/GetUserPermitionData/${ObjectID}/${ObjectID}`);
    },
};
